import { render, staticRenderFns } from "./group-box.vue?vue&type=template&id=5ddbc8dd&scoped=true"
import script from "./group-box.vue?vue&type=script&lang=js"
export * from "./group-box.vue?vue&type=script&lang=js"
import style0 from "./group-box.vue?vue&type=style&index=0&id=5ddbc8dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddbc8dd",
  null
  
)

export default component.exports